module.exports = __webpack_public_path__ + "static/04-ca5fae0705a7d3178104a7d03e208490.jpg";